import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveTickets } from '@ttstr/actions';
import { Container, LoadingSpinner, useIntl, Masonry, ContentrArea } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

const TicketListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, tickets } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveTickets();
  }, [language]);

  return (
    <div>
      {/* <Container fluid className="header-image header-tickets" /> */}

      <article className="pb-5 ticket-listing mb-5">
        <Container className="list-page mt-0">
          <Helmet>
            <title>{t(`TICKETLISTING.TITLE`)}</title>
            <body className="ticket-listing-page hidden-ticketlisting" />
          </Helmet>

          <ContentrArea id="above-listing" />

          <h1 className="text-center mb-3">{t(`LIVE TOUR 2028`)}
          </h1>
          <h2 className='text-center text-white ff-accent mb-5'>WEIL NACH DER TOUR VOR DER TOUR IST. ♥</h2>

          {loading ? ( // if loading
            <LoadingSpinner label={t(`LOADING.TICKETS`)} />
          ) : tickets.length === 0 ? ( // if no tickets
            <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
          ) : (
            // else show tickets
            <Masonry
              id="ticket-listing"
              products={tickets.filter((t) => t.tag_ids.includes(10380))}
              type="list"
              // filters={['soldOut']}
              showCity
              showLocation
              showSubtitle
              showTags
            />
          )}

          {/* <div className="text-center mt-3">
            <h4>
              <a href="/termine">Weitere Termine →</a>
            </h4>
          </div> */}

          {/* <h1 className="text-center my-5">{t(`Andere Events`)}</h1>

          {loading ? ( // if loading
            <LoadingSpinner label={t(`LOADING.TICKETS`)} />
          ) : tickets.length === 0 ? ( // if no tickets
            <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
          ) : (
            // else show tickets
            <Masonry
              id="ticket-listing"
              products={tickets.filter((t) => !t.tag_ids.includes(9359))}
              type="list"
              // filters={['soldOut']}
              showCity
              showLocation
              showSubtitle
              showTags
            />
          )} */}

          <ContentrArea id="below-listing" />
        </Container>
      </article>
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets, loading } = state.Tickets;
  return {
    tickets,
    loading,
  };
};

const mapDispatchToProps = {
  receiveTickets,
};

export default React.memo(TicketListing);
